import { Form, Formik } from 'formik';
import * as Yup from "yup";
import { Box } from '@mui/material';
import FormGroup from '../shared/containers/FormGroup';
import Input from '../shared/formInput/Input';
import PrimaryButton from '../shared/buttons/PrimaryButton';
import CountrySelectInput from '../shared/formInput/CountrySelectInput';
import DateInput from '../shared/formInput/DateInput';
import { useNavigate } from 'react-router-dom';
import CheckBoxInput from '../shared/formInput/CheckBoxInput';
import { handleExcludedFields } from '../../utils/form';
import Divider from '@mui/material/Divider';
import './ContractInfoForm.css';
import { SvgIcon } from "@mui/material";
import Logo from "../shared/Logo";

const ContractInfoForm = ({submitButtonChildren, requestActionHandler, extraFields, extraFieldsYupValidation, children}) => {
    const navigate = useNavigate();
    const excludeField = ['info_validated_by_user'];
    const initialValues = {
        street_name: '',
        zip_code: '',
        city: '',
        compl_adress: '',
        date_of_birth: '',
        city_of_birth: '',
        country_of_birth: '',
        nationality: '',
        social_security_num: '',
        info_validated_by_user: false,
        ...extraFields
    };

    const onSubmit = async (values, {resetForm, setErrors, setSubmitting}) => {
        try {
            values = handleExcludedFields(values, excludeField);
            await requestActionHandler(values);
            navigate('/', {replace: true});
        } catch (error) {
            setErrors({createError: error.message})
            // console.error(error)
        }
    };

    const validationSchema = Yup.object({
        street_name: Yup.string()
            .required("champ requis"),
        zip_code: Yup.string()
            .matches(/^\d{5}$/, { message: "format: 12345", excludeEmptyString: true })
            .required("champ requis"),
        city: Yup.string()
            .required("champ requis"),
        date_of_birth: Yup.string()
            .required("champ requis"),
        city_of_birth: Yup.string()
            .required("champ requis"),
        country_of_birth: Yup.string()
            .required("champ requis"),
        nationality: Yup.string()
            .required("champ requis"),
        social_security_num: Yup.string()
            .matches(/^[1-478][0-9]{2}(0[1-9]|1[0-2]|62|63)(2[ABab]|[0-9]{2})(00[1-9]|0[1-9][0-9]|[1-8][0-9]{2}|9[0-8][0-9]|990)(00[1-9]|0[1-9][0-9]|[1-9][0-9]{2})(0[1-9]|[1-8][0-9]|9[0-7])$/, { message: "Format incorrect", excludeEmptyString: true })
            .required("champ requis"),
        ...extraFieldsYupValidation
    });

    const formStyle = {
        width: "fit-content",
        margin: "2em auto 2em"
    };

    const welcomeMessage = `Vous avez fait le choix de rejoindre Dalkia Froid Solutions et nous vous en remercions. Rejoindre Dalkia Froid Solutions, c’est rejoindre une entreprise résolument orientée vers la transition énergétique. Notre vocation est d’assurer une performance énergétique durable à chacun de nos clients. Nous sommes ravis de pouvoir compter sur vous pour mener ensemble cette mission.

Afin de pouvoir finaliser votre processus de recrutement, nous vous remercions de compléter le formulaire ci-dessous. Ces informations nous permettront d’établir votre contrat de travail que vous recevrez par mail pour signature via notre plateforme Docusign.

Dès que vous aurez complété ce formulaire, vous accèderez au portail DFS&moi. Ce portail vous permettra de découvrir notre environnement.`

    const rgpdMessage = `Les données à caractère personnel (« DCP ») collectées sur ce formulaire font l’objet d’un traitement automatisé par DALKIA FROID SOLUTIONS, rue Fabien Cesbron, Saint-Sylvain d'Anjou, 49484 Verrières-en-Anjou, responsable de traitement, ayant pour finalité principale la gestion d’un fichier de recrutement, sur la base de votre consentement. Nous vous fournissons toutes les informations sur la page "Politique de confidentialité" de notre site.`

    return (              
        <Formik {...{ initialValues, onSubmit, validationSchema, enableReinitialize:true}}>
            {({errors, isValid, dirty, values}) => {
                return (
                <Box sx={formStyle}>
                    {errors.createError && <p>{errors.createError}</p>}
                    <Form autoComplete="off" style={{paddingRight: "0.5em", paddingLeft: "0.5em"}}>
                        <div class="header">
                            <SvgIcon component={Logo}  {...{maxHeight: "48px"}}/>
                            <h1 style={{textAlign: 'left'}}>Bienvenue</h1>                              
                        </div>                                         
                        <div style={{width: "10em", marginBottom: '2vh'}}>
                            <Divider variant="fullWidth" sx={{ borderBottomWidth: "0.2em" }} />  
                        </div>           
                        <pre class="welcome-div">
                            {welcomeMessage}
                        </pre>
                        {children}
                        <FormGroup>
                            <Input
                                {...{
                                    name: "street_name",
                                    label: "N° et voie",
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Input
                                {...{
                                    name: "compl_adress",
                                    label: "Complément d'adresse",
                                    required: false
                                }}
                            />
                        </FormGroup>
                        <FormGroup multi>
                            <Input
                                {...{
                                    name: "zip_code",
                                    label: "Code postal",
                                }}
                            />
                            <Input
                                {...{
                                    name: "city",
                                    label: "Nom de la ville",
                                }}
                            />
                        </FormGroup>                                
                        <FormGroup multi>
                            <DateInput 
                                {...{
                                    name: "date_of_birth",
                                    label: "Date de naissance"
                                }}
                            />
                            <Input
                                {...{
                                    name: "city_of_birth",
                                    label: "Ville de naissance",
                                }}
                            />
                            <CountrySelectInput
                                {...{
                                    name: "country_of_birth",
                                    label: "Pays de naissance",
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <CountrySelectInput
                                {...{
                                    name: "nationality",
                                    label: "Nationalité",
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Input
                                {...{
                                    name: "social_security_num",
                                    label: "N° de sécurité sociale",
                                    helperText: "sans espaces"
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <CheckBoxInput
                                single
                                {...{
                                    name: "info_validated_by_user",
                                    label: "Je confirme les informations renseignées ci-dessus",
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <pre class="rgpd-div">
                                {rgpdMessage}
                            </pre>
                        </FormGroup>
                        <PrimaryButton type="submit" disabled={!isValid || !dirty || !values.info_validated_by_user} style={{marginTop: "0.5em"}}>
                            {submitButtonChildren}
                        </PrimaryButton>
                    </Form>
                </Box>
            )}}
        </Formik>           
    );
}

export default ContractInfoForm;
